// src/hooks/useProjects.js
// ─────────────────────────────────────────────────────────
// Real-time projects list. Auto-updates when Firestore changes.
// ─────────────────────────────────────────────────────────

import { useState, useEffect } from 'react';
import { subscribeToProjects, createProject, deleteProject } from '../lib/db';

export function useProjects(uid) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    if (!uid) return;
    setLoading(true);
    const unsub = subscribeToProjects(uid, (data) => {
      setProjects(data.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0)));
      setLoading(false);
    });
    return unsub;
  }, [uid]);

  const create = (name) => createProject(uid, name);
  const remove = (id)   => deleteProject(uid, id);

  return { projects, loading, create, remove };
}